import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';
import { typeLabels } from '@/mocks/videos';
import { formatCount } from '@/utils/video';

interface VideoCardProps {
  video: VideoItem;
  showDescription?: boolean;
}

export default function VideoCard({ video, showDescription = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating.toFixed(1)}
        </div>
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-800 text-xs">
          {typeLabels[video.type]}
        </div>
        <div className="absolute bottom-2 left-2 px-2 py-0.5 rounded-full bg-black/60 text-background-50 text-xs">
          {video.status}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-4">{video.description}</p>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-medium text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {video.title}
        </h3>
        <div className="mt-1.5 flex items-center flex-wrap gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span>·</span>
          <span>{video.region}</span>
          <span>·</span>
          <span>{video.subType}</span>
        </div>
        <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            {formatCount(video.views)}
          </span>
          <span>{video.updateDate}</span>
        </div>
        {showDescription && (
          <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">{video.description}</p>
        )}
      </div>
    </Link>
  );
}